import(/* webpackMode: "eager" */ "/app/src/app/company/careers/layout.tsx");
